import { AlertTriangle, ArrowLeft, Home } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../ui/button";

export function ErrorScreen() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-n-bg-1">
      <header className="bg-n-green fixed inset-x-0 top-0 z-50">
        <div className="flex h-[56px] container items-center justify-between md:h-[72px]">
          <Link to="/" className="flex items-center gap-3">
            <img
              src="/images/logo_xl.png"
              alt="Nacional GO"
              width={120}
              height={28}
              className="h-4 md:h-6 w-auto"
            />
            <span className="sr-only">Nacional GO</span>
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center mt-[56px] md:mt-[72px] px-5">
        <div className="text-center max-w-md">
          <div className="flex justify-center mb-6">
            <div className="bg-red-100 rounded-full p-4">
              <AlertTriangle className="h-10 w-10 text-red-500" />
            </div>
          </div>

          <h1 className="text-2xl md:text-3xl font-bold text-n-text-green mb-3">
            Algo deu errado
          </h1>
          <p className="text-n-text-neutral mb-8">
            Ocorreu um erro inesperado. Tente voltar ou acessar a página
            inicial.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              onClick={() => navigate(-1)}
              className="flex items-center gap-2"
            >
              <ArrowLeft className="h-4 w-4" />
              Voltar
            </Button>
            <Link to="/">
              <Button className="flex items-center gap-2 w-full sm:w-auto">
                <Home className="h-4 w-4" />
                Ir para o início
              </Button>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}

export function LoadingScreen() {
  return (
    <div className="py-6 sm:py-10 w-full max-w-7xl mx-auto">
      <h1 className="text-2xl sm:text-3xl font-bold text-n-green mb-10">
        Carregando...
      </h1>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <div className="lg:col-span-8 flex flex-col gap-6">
          <div className="space-y-4 rounded-2xl bg-white px-5 py-4 sm:px-8 sm:py-6 shadow-sm animate-pulse">
            <div className="h-6 bg-gray-300 rounded w-1/3 mb-4"></div>
            <div className="h-4 bg-gray-300 rounded w-1/2 mb-2"></div>
            <div className="h-4 bg-gray-300 rounded w-1/4 mb-2"></div>
            <div className="h-4 bg-gray-300 rounded w-1/3"></div>
          </div>

          <div className="space-y-4 rounded-2xl bg-white px-5 py-4 sm:px-8 sm:py-6 shadow-sm animate-pulse">
            <div className="h-6 bg-gray-300 rounded w-1/3 mb-4"></div>
            <div className="h-4 bg-gray-300 rounded w-1/2 mb-2"></div>
            <div className="h-4 bg-gray-300 rounded w-1/4 mb-2"></div>
            <div className="h-4 bg-gray-300 rounded w-1/3"></div>
          </div>
        </div>

        <div className="lg:col-span-4 flex flex-col gap-4">
          <div className="rounded-2xl bg-white px-5 py-4 sm:px-8 sm:py-6 shadow-sm animate-pulse">
            <div className="h-6 bg-gray-300 rounded w-1/3 mb-4"></div>
            <div className="h-4 bg-gray-300 rounded w-1/2 mb-2"></div>
            <div className="h-4 bg-gray-300 rounded w-1/4 mb-2"></div>
          </div>

          <div className="rounded-2xl bg-white px-5 py-4 sm:px-8 sm:py-6 shadow-sm animate-pulse">
            <div className="h-6 bg-gray-300 rounded w-1/3 mb-4"></div>
            <div className="h-4 bg-gray-300 rounded w-1/2 mb-2"></div>
            <div className="h-4 bg-gray-300 rounded w-1/4 mb-2"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
